require(['jquery', 'js/glider-min'], function ($) {
	const heroSliders = document.querySelectorAll(".js-teaser-slider-reborn-slider");
	const prevButton = document.querySelector('.js-teaser-slider-reborn-slider-prev');
	const nextButton = document.querySelector('.js-teaser-slider-reborn-slider-next');

	if (heroSliders) {
		heroSliders.forEach(heroSlider => {
			const sliderDataId = heroSlider.getAttribute('data-uid');
			const glider = new Glider(heroSlider, {
				slidesToShow: 3,
				slidesToScroll: 1,
				draggable: true,
				scrollLock: true,
				rewind: true,
				arrows: {
					prev: ".js-teaser-slider-reborn-slider-prev.slider-id-"+sliderDataId,
					next: ".js-teaser-slider-reborn-slider-next.slider-id-"+sliderDataId
				},
				dots: '.js-teaser-slider-reborn-slider-bullets'
			});

			glider.isLastSlide = function() {
				return slider.page >= slider.dots.childElementCount - 1;
			}

			let autoplayDelay = 3000;

			let timeout = -1;
			let hovering = false;
			let isFocused = false;

			function startTimeout() {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					if (!hovering && !isFocused)
						glider.scrollItem((glider.slide + 1) % glider.slides.length);
				}, autoplayDelay);
			}

			let animID = 0;
			const isAnimating = () => glider.animate_id !== animID;
			const prevButton = heroSlider.closest('.c-teaser-slider-reborn-slider').querySelector('.js-teaser-slider-reborn-slider-prev');
			const nextButton = heroSlider.closest('.c-teaser-slider-reborn-slider').querySelector('.js-teaser-slider-reborn-slider-next');


			heroSlider.addEventListener('mouseover', (event) => {
				hovering = true;
				clearTimeout(timeout);
			});

			nextButton.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			nextButton.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			prevButton.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			prevButton.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			heroSlider.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			heroSlider.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			heroSlider.addEventListener("glider-animated", function (event) {
				animID = glider.animate_id;
				if (!hovering && !isFocused) {
					startTimeout();
				}
			});


			startTimeout();
		})
	}
	window.addEventListener('load', (event) => {
		function hideArrowsAndBulletsIfSingleItem() {
			if (!heroSliders) {
				return;
			}
			const heroSliderItems = document.querySelectorAll('.c-teaser-slider-reborn-slider__item');
			const arrowsElements = document.querySelectorAll('.c-teaser-slider-reborn-slider__arrows');
			const bulletsElement = document.querySelector('.c-teaser-slider-reborn-slider__bullets');

			if (heroSliderItems.length === 1) {
				arrowsElements.forEach(element => {
					element.style.display = 'none';
				});

				if (bulletsElement) {
					bulletsElement.style.display = 'none';
				}
			}
		}
		hideArrowsAndBulletsIfSingleItem();
	})

	const heroSliders_mobile = document.querySelectorAll(".js-teaser-slider-reborn-slider-mobile");
	const prevButton_mobile = document.querySelector('.js-teaser-slider-reborn-slider-mobile-prev');
	const nextButton_mobile = document.querySelector('.js-teaser-slider-reborn-slider-mobile-next');

	if (heroSliders_mobile) {
		heroSliders_mobile.forEach(heroSlider => {
			const sliderDataId = heroSlider.getAttribute('data-uid');
			const glider_mobile = new Glider(heroSlider, {
				slidesToShow: 1.1,
				slidesToScroll: 1,
				draggable: true,
				scrollLock: true,
				rewind: true,
				arrows: {
					prev: ".js-teaser-slider-reborn-slider-mobile-prev.slider-id-"+sliderDataId,
					next: ".js-teaser-slider-reborn-slider-mobile-next.slider-id-"+sliderDataId
				},
				dots: '.js-teaser-slider-reborn-slider-mobile-bullets'
			});

			glider_mobile.isLastSlide = function() {
				return slider.page >= slider.dots.childElementCount - 1;
			}

			let autoplayDelay = 3000;

			let timeout = -1;
			let hovering = false;
			let isFocused = false;

			function startTimeout() {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					if (!hovering && !isFocused)
						glider_mobile.scrollItem((glider_mobile.slide + 1) % glider_mobile.slides.length);
				}, autoplayDelay);
			}

			let animID = 0;
			const isAnimating = () => glider_mobile.animate_id !== animID;
			const prevButton_mobile = heroSlider.closest('.c-teaser-slider-reborn-slider').querySelector('.js-teaser-slider-reborn-slider-mobile-prev');
			const nextButton_mobile = heroSlider.closest('.c-teaser-slider-reborn-slider').querySelector('.js-teaser-slider-reborn-slider-mobile-next');


			heroSlider.addEventListener('mouseover', (event) => {
				hovering = true;
				clearTimeout(timeout);
			});

			nextButton_mobile.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			nextButton_mobile.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			prevButton_mobile.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			prevButton_mobile.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			heroSlider.addEventListener('focusin', (event) => {
				isFocused = true;
				clearTimeout(timeout);
			});

			heroSlider.addEventListener('focusout', (event) => {
				isFocused = false;
				startTimeout();
			});

			heroSlider.addEventListener("glider-animated", function (event) {
				animID = glider_mobile.animate_id;
				if (!hovering && !isFocused) {
					startTimeout();
				}
			});


			startTimeout();
		})
	}
	window.addEventListener('load', (event) => {
		function hideArrowsAndBulletsIfSingleItem() {
			if (!heroSliders_mobile) {
				return;
			}
			const heroSliderItems = document.querySelectorAll('.c-teaser-slider-reborn-slider__item');
			const arrowsElements = document.querySelectorAll('.c-teaser-slider-reborn-slider__arrows');
			const bulletsElement = document.querySelector('.c-teaser-slider-reborn-slider__bullets');

			if (heroSliderItems.length === 1) {
				arrowsElements.forEach(element => {
					element.style.display = 'none';
				});

				if (bulletsElement) {
					bulletsElement.style.display = 'none';
				}
			}
		}
		hideArrowsAndBulletsIfSingleItem();
	})

});

